
export const requestPublicOpenClosingPriceQuery = () => `
    query publicOpenClosingPrice($fromDate: String!, $toDate: String!, $symbol: String!) {
        publicOpenClosingPrice(fromDate: $fromDate, toDate: $toDate, symbol: $symbol) {
            symbol
            market_symbol
            market_name
            exchange_symbol
            exchange_name
            trading_date
            open
            open_yield
            high
            high_yield
            low
            low_yield
            close
            official_last
            official_last_corrected
            official_last_yield_corrected
            close_yield
            volume
            turnover
            number_of_trades
            number_of_alerts
        }
    }
`;

export const requestPublicOrdersQuery = () => `
    query publicOrders($fromDate: String!, $toDate: String!, $symbol: String!) {
        publicOrders(fromDate: $fromDate, toDate: $toDate, symbol: $symbol) {
            order_id
            trade_date
            symbol
            side
            price
            quantity
            value
            yield
            dirty_price
            price_per_point
            duration
            member
            update_code
            order_timestamp
            inserted
            updated
            order_timestamp_utc
            deleted_timestamp
            deleted_timestamp_utc
        }
    }
`;

export const requestPublicTradesQuery = () => `
    query publicTrades($fromDate: String!, $toDate: String!, $symbol: String!) {
        publicTrades(fromDate: $fromDate, toDate: $toDate, symbol: $symbol) {
            symbol
            trade_date
            trade_number
            time_exec
            time_exec_utc
            trade_cancel
            timestamp_agreement
            timestamp_trade_cancel
            timestamp_dissemination
            settlement_date
            price
            volume
            value
            yield
            price_dirty
            duration
            price_per_point
            trade_buyer
            trade_seller
            trade_type
            trade_class
            trade_updates_last_paid
            trade_updates_high_low
            trade_updates_average
            trade_updates_turnover
            is_latest_trade
            outside_spread
            trade_id
            aggressive_party
        }
    }
`;

export const requestPublicClosingPriceQuery = () => `
    query publicClosingPrice($day: String!, $symbol: String!) {
        publicClosingPrice(day: $day, symbol: $symbol) {
            symbol
            market_symbol
            market_name
            exchange_symbol
            exchange_name
            trading_date
            open
            open_yield
            high
            high_yield
            low
            low_yield
            close
            official_last
            official_last_corrected
            official_last_yield_corrected
            close_yield
            volume
            number_of_trades
            paid_last
            bid_price
            ask_price
            bid_yield
            ask_yield
        }
    }
`;

export const requestPublicPreviousTradingDayQuery = () => `
    query publicPreviousTradingDay($day: String!, $symbol: String!) {
        publicPreviousTradingDay(day: $day, symbol: $symbol) {
            day
        }
    }
`;